module.exports = "../../static/img/profi_planet_logo.cd6b76a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profi_planet_logo.png
// module id = 361
// module chunks = 1